var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "h3",
    {
      staticClass:
        "flex flex-col items-center text-center text-xl leading-9 font-extrabold text-gray-900",
    },
    [
      _vm._t("default", function () {
        return [_vm._v(" " + _vm._s(_vm.content) + " ")]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }